<template>
  <div class="jianbao_box">
    <m-title></m-title>
    <div class="cont">
      <div class="changdi">
        <div class="changdi_left">
          <span>计划来源</span>
          <div class="select_box">
            <el-select v-model="changdival" placeholder="请选择"  @input="changdiselect">
              <el-option v-for="it in changdisel" :key="it.value" :value="it.value" :label="it.label"></el-option>
            </el-select>
          </div>
          <div v-for="item in ywtype" :key="item.type" :class="[ywindex == item.type ? 'active' : 'ywstyle']"
            @click="checkywindex(item.type)">{{ item.name }}</div>
        </div>
        <div class="clear_search">
          <button class="chaxun" @click="getsearch">查询</button>
          <button class="reset" @click="reset">重置</button>
        </div>
      </div>
      <div class="yunshutongji">
        <div class="tongji-title">
          <div class="echarts-title">
            <div class="left-bac"></div>
            <div class="left-name">运输统计</div>
          </div>
          <div class="clear_search">
            <div v-for="item in ysbutton" :key="item.type" :class="[tjindex == item.type ? 'active' : 'ywstyle']"
            @click="checktongjiindex(item.type)">{{ item.name }}</div>
            <!-- <button>完成计划</button>
            <button>运输车队</button>
            <button>派车数</button>
            <button>车辆数</button>
            <button>运输车次</button>
            <button>运输吨数</button> -->
          </div>
        </div>
        
        <div class="echartsinfo" ref="echartsinfo"></div>
      </div>
      <div class="zuoyejianbao" v-for="item in zuoyelist" :key="item.id">
        <div class="echarts-title">
          <div class="left-bac"></div>
          <div class="left-name">{{item.time}}{{danwei==3?'日':danwei==4?'月':''}}作业简报</div>
        </div>
        <div class="zuoyedetails">
          <div class="jb zy1" style="color: #1B6B9B;cursor: pointer;" @click="godetail('zuoyechaxun',item)">
            <div class="number">{{ item.planedCount }}</div>
            <div class="name">完成计划</div>
            <img src="../../assets/homeImg/icon_figer.png" alt="">
          </div>
          <div class="jb zy2" style="color: #2F419B;cursor: pointer;" @click="godetail('zuoyechaxun',item)">
            <div class="number">{{ item.fleetCount }}</div>
            <div class="name">运输车队</div>
            <img src="../../assets/homeImg/icon_figer.png" alt="">
          </div>
          <div class="jb zy3" style="color:#115B76;cursor: pointer;" @click="godetail('zuoyechaxun',item)">
            <div class="number">{{ item.dispathCount }}</div>
            <div class="name">派车数</div>
            <img src="../../assets/homeImg/icon_figer.png" alt="">
          </div>
          <div class="jb zy2" style="color: #2F419B;cursor: pointer;" @click="godetail('zuoyechaxun',item)">
            <div class="number">{{ item.fleetCarOnWorkCount }}</div>
            <div class="name">车辆数</div>
            <img src="../../assets/homeImg/icon_figer.png" alt="">
          </div>
          <div class="jb zy4" style="color: #533796;cursor: pointer;" @click="godetail('jobdetails',item)">
            <div class="number">{{ item.carWorkedCount }}</div>
            <div class="name">运输车次</div>
            <img src="../../assets/homeImg/icon_figer.png" alt="">
          </div>
          <div class="jb zy5" style="color: #2F419B;cursor: pointer;" @click="godetail('jobdetails',item)">
            <div class="number">{{ item.carWorkedDun }}</div>
            <div class="name">运输吨数</div>
            <img src="../../assets/homeImg/icon_figer.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mTitle from '@/components/mTitle.vue';
import * as echarts from 'echarts';
import dayjs from 'dayjs';
export default {
  data() {
    return {
      changdisel:[
        { label: "前沿货场", value: "jiaotan" },
        { label: "港俊货场", value: "gangjun" },
        { label: "昊德", value: "haode" },
        { label: "琦晟", value: "qisheng" },
        { label: "睿鑫", value: "ruixin" },
        { label: "通达", value: "tongda" },
        { label: "富泉", value: "fuquan" },
      ],
      changdival: "jiaotan",
      ywtype: [
        { name: "近一周", type: 2 },
        { name: "近一月", type: 3 },
        { name: "近一年", type: 4 },
      ],
      ysbutton:[
        { name: "完成计划", type: 1 },
        { name: "运输车队", type: 2 },
        { name: "派车数", type: 3 },
        { name: "车辆数", type: 4 },
        { name: "运输车次", type: 5 },
        { name: "运输吨数", type: 6 },
      ],
      ywindex: 2,
      tjindex: 1,
      danwei:null,
      echartsinfo: null,
      currentMonth: dayjs().format('MM'),
      currentYear: dayjs().format('YYYY'),
      // rowcenter: {
      //   "text-align": "center"
      // },
      zuoyelist:[],
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        grid: {
          left: '5%',
          right: '5%'
        },
        toolbox: {
          right:'10%',
          feature: {
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
          }
        },
        legend: {
          data: ['运输吨数']
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '单位：吨',
            min: 0,
            alignTicks: true,
            axisLabel: {
              formatter: '{value} '
            }
          },
          {
            type: 'value',
            // name: '单位：车次',
            min: 0,
            axisLabel: {
              formatter: '{value} '
            }
          }
        ],
        series: [
          {
            name: '运输吨数',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1, // x1, y1, x2, y2 定义渐变方向
                [
                  { offset: 1, color: '#17B6A1' },
                  { offset: 0, color: 'rgba(100,200,100,0.5)' }
                ]
              )
            },
            barWidth: '30%',
            data: []
          },
          {
            name: '运输车次',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          }
        ]
      },
    }
  },
  components: {
    mTitle,
  },
  mounted() {
    this.$nextTick(() => {
      this.echartsinfo = echarts.init(this.$refs.echartsinfo)
    })
    this.getsearch()

    window.addEventListener('resize', () => {
      this.echartsinfo.resize()

    })
  },
  methods: {
    godetail(str,item){
      let name
      let obj={
        stname:this.changdival,
      }
      switch (str) {
        case 'zuoyechaxun':
          name="zuoyechaxun"
          // obj.plantype=3
          obj.status=1
          obj.startTime=item.startTime
          obj.endTime=item.endTime
          if(item.planedCount){
            this.$router.push({name,query:{obj:JSON.stringify(obj)}})
          }else{
            return
          }
          break;
        // case 'zuoyechaxun':
        //   name="zuoyechaxun"
        //   // obj.plantype=3
        //   // obj.status=1
        //   // obj.selectVal='完成'
        //   obj.startTime=item.startTime
        //   obj.endTime=item.endTime
        //   if(item.planedCount){
        //     this.$router.push({name,query:{obj:JSON.stringify(obj)}})
        //   }else{
        //     return
        //   }
        //   break;
        case 'jobdetails':
          name="jobdetails"
          obj.plantype=3
          obj.startTime=item.startTime
          obj.endTime=item.endTime
          if(item.carWorkedCount){
            this.$router.push({name,query:{obj:JSON.stringify(obj)}})
          }else{
            return
          }
          break;
      }
      
    },
    //选择货场
    changdiselect(e) {
      this.changdival = e
    },
    //选择时间
    checkywindex(index) {
      this.ywindex = index
    },
    checktongjiindex(index){
      this.tjindex=index
    },
    //查询/home/statistics/carWorkReport
    async getsearch() {
      this.danwei=this.ywindex
      try {
        const { data } = await this.$http(
            "api1",
            '/home/statistics/carWorkReport',
            "get",
            {stname:this.changdival,type:this.ywindex}
        )
        if(data.code!==0) throw error;
        this.zuoyelist=data.data
        this.option.xAxis[0].data = []
        this.option.series[0].data = []
        this.option.series[1].data = []
        data.data.forEach(item => {
          this.option.xAxis[0].data.push(item.time)
          switch (this.tjindex) {
            case 1:
              this.option.series[0].data.push(item.planedCount)
              this.option.yAxis[0].name='单位：个'
              break;
            case 2:
              this.option.series[0].data.push(item.fleetCount)
              this.option.yAxis[0].name='单位：个'
              break;
            case 3:
              this.option.series[0].data.push(item.dispathCount)
              this.option.yAxis[0].name='单位：辆'
              break;
            case 4:
              this.option.series[0].data.push(item.fleetCarOnWorkCount)
              this.option.yAxis[0].name='单位：辆'
              break;
            case 5:
              this.option.series[0].data.push(item.carWorkedCount)
              this.option.yAxis[0].name='单位：次'
              break;
            case 6:
              this.option.series[0].data.push(item.carWorkedDun)
              this.option.yAxis[0].name='单位：吨'
              break;
          }
          // this.option.series[0].data.push(item.carWorkedDun)
          // this.option.series[1].data.push(item.carWorkedCount)
        });
        this.$nextTick(() => {
          this.echartsinfo.setOption(this.option);
        })
      } catch (error) {
        console.log(error);
      }
     
       
    },
    //重置
    reset() {
      this.changdival = "jiaotan";
      this.ywindex = 2;
      this.getsearch();
    },
  },
}
</script>

<style lang="scss" scoped>
.jianbao_box {
  width: 100%;
  height: 100%;

  .cont {
    position: relative;
    width: 100%;
    height: calc(100% - 50px);
    background-color: #f5f6fa;
    padding: 10px;
    box-sizing: border-box;
    overflow: auto;
    .changdi {
      width: 100%;
      height: 50px;
      background-color: #fff;
      margin: 10px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
      border-radius: 8px;

      .changdi_left {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .select_box {
          display: inline-block;
          font-weight: 400;
          width: 120px;
          height: 30px;
          vertical-align: middle;
          margin-left: 10px;
          background: #f3f4f5;
          line-height: 30px;
          margin-right: 100px;
        }

        .ywstyle {
          width: 80px;
          height: 30px;
          border: 1px solid #17B6A1;
          border-radius: 4px;
          text-align: center;
          line-height: 30px;
          font-size: 16px;
          color: #17B6A1;
          margin-left: 15px;
          cursor: pointer;
        }

        .active {
          width: 80px;
          height: 30px;
          border: 1px solid #17B6A1;
          border-radius: 4px;
          text-align: center;
          line-height: 30px;
          font-size: 16px;
          color: #fff;
          background-color: #17B6A1;
          margin-left: 15px;
          cursor: pointer;
        }
      }

      .clear_search {
        .chaxun {
          width: 80px;
          height: 30px;
          background: #17B6A1;
          border-radius: 8px;
          color: #fff;
          line-height: 30px;
          text-align: center;
          border: none;
          font-size: 80%;
        }

        .reset {
          width: 80px;
          height: 30px;
          background-color: #F5F6FA;
          border-radius: 8px;
          color: #17B6A1;
          line-height: 30px;
          text-align: center;
          border: none;
          font-size: 80%;
          margin-left: 19px;
        }
      }
    }

    .yunshutongji,
    .zuoyejianbao {
      width: 100%;

      background: #FFFFFF;
      border-radius: 8px;
      margin-top: 20px;
      padding: 0 34px;
      box-sizing: border-box;
      .tongji-title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .clear_search{
          display: flex;
          .ywstyle {
          width: 80px;
          height: 30px;
          border: 1px solid #17B6A1;
          border-radius: 4px;
          text-align: center;
          line-height: 30px;
          font-size: 16px;
          color: #17B6A1;
          margin-left: 15px;
          cursor: pointer;
        }

        .active {
          width: 80px;
          height: 30px;
          border: 1px solid #17B6A1;
          border-radius: 4px;
          text-align: center;
          line-height: 30px;
          font-size: 16px;
          color: #fff;
          background-color: #17B6A1;
          margin-left: 15px;
          cursor: pointer;
        }
        }
      }
      .echarts-title {
        padding: 25px 0 20px 0;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .left-bac {
          width: 12px;
          height: 26px;
          background: #17B6A1;
          border-radius: 6px;
          margin-right: 11px;
        }

        .left-name {
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #2D3748;
        }
      }

      .zuoyedetails {
        padding-bottom: 20px;
        display: flex;
        justify-content: space-evenly;

        .jb {
          width: 16%;
          height: 150px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          position: relative;
          .number {
            font-size: 30px;
            font-weight: 600;
            margin-bottom: 15px;
          }

          .name {
            font-size: 14px;
          }
          img{
            width: 20px;
            height: 30px;
            position: absolute;
            right: 15px;
            bottom: 15px;
          }
        }

        @for $i from 1 through 5 {
          .zy#{$i} {
            background-image: url(../../assets/zuoye/zy#{$i}.png);
            background-size: 100% 100%;
            background-repeat: no-repeat
          }
        }

      }

      .echartsinfo {
        height: 400px;
        width: 100%;
      }
    }
  }

}
</style>